import React from 'react'
import { Box } from '@mui/material'
import TransportoForm from './TransportoForm'

export const TrasportoSlider = ({setCantine}) => {

    return (
        <Box className='customDrawer_container'>
            <Box className='boxContainer__head'>
                <h2 className="boxContainer__title">Registra un Viaggio</h2>
            </Box>
            <TransportoForm setCantine={setCantine} />
        </Box>
    )
}
